/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Filename_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter a filename here" |
*
* @param {Markers_Filename_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_filename_placeholder = /** @type {((inputs?: Markers_Filename_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Filename_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisir un nom de fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie hier einen Dateinamen ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci qui un nome file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите имя файла здесь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca un nombre de archivo aquí")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请在此处输入文件名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ここにファイル名を入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यहां फ़ाइल का नाम दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira o nome do arquivo aqui.")
	return /** @type {LocalizedString} */ ("Enter a filename here")
});